import React from "react";

interface RibbonImageProps {
    imageUrl: string;
    ribbonText?: string;
}

const RibbonImage: React.FC<RibbonImageProps> = ({imageUrl, ribbonText}) => {
    const showRibbon = !!ribbonText;
    const grayscaleFilter = showRibbon ? "grayscale(100%)" : "";

    const noImageUrl = "https://prontonubestorage.blob.core.windows.net/resources/img/noimage.jpeg";

    return (
        <div className="ribbon-image-container">
            <img
                className="ribbon-image"
                src={imageUrl}
                alt="ribbon"
                onError={(e) => e.currentTarget.src = noImageUrl}
                style={{filter: grayscaleFilter}}
            />
            {showRibbon && (
                <div className="ribbon">
                    <span className="ribbon-text">{ribbonText}</span>
                </div>
            )}
        </div>
    );
};

export default RibbonImage;
